<template>
  <div class="Processline">
    <div class="tag">
      <div class="line"></div>
      <div class="triangle"></div>
    </div>
  </div>
</template>

<script>
 export default {
   name: '',
   props: {
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Processline{
   margin-top: 2.5vw;
   width: 8.125vw;
   height: 0;
   display: flex;
   justify-content:center;
   position: relative;
 }
 .tag{
   width: 100%;
   position: absolute;
   top: -7px;
   display:flex;
 }
.line {
  width: 100%;
  height: 1px;
  margin-top: 3px;
  margin-left: -3px;
  border-top: 1px dashed black;
}
 .triangle{
   width: 0;
   height: 0;
   border-top: 3px solid transparent;
   border-bottom: 3px solid transparent;
   border-left: 6px solid black;
 }
 .darker{
   border-left: 12px solid #5A5AFF;
 }
 @media (min-width: 320px) and (max-width: 480px) {
   .Processline{
     margin-top: 3.8vw;
     width: 12.125vw;
     border-top: dashed 1px white;
   }
   .tag{
     position: absolute;
     top: -4.2px;
     display:flex;
   }
   .triangle{
     border-top: 3px solid transparent;
     border-bottom: 3px solid transparent;
     border-left: 6px solid #B1B1FF;
   }
   .darker{
     border-left: 6px solid #5A5AFF;
   }
 }
</style>
